/* eslint-disable */
import { Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import RoomIcon from '@material-ui/icons/Room';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { fromEvent, merge } from 'rxjs';
import { switchMap, tap, debounceTime } from 'rxjs/operators';
import withServices from '../../Contexts/Services/WithServices.context';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Autocomplete from '../Autocomplete/Autocomplete.component';
import HereMapsStyles from './HereMaps.component.styles';
import PlaceOrderErrorMessage from '../PlaceOrder/PlaceOrderErrorMessage.component';

/**
 * HereMapsAutocomplete
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const HereMapsAutocomplete = ({ classes, services, onSelect, onClear, defaultAddress, onError, disabled, mandatoryFieldError }) => {
  const [defaultValue, setDefaultValue] = useState(defaultAddress || ``);
  const [filterText, setFilterText] = useState(``);
  const [options, setOptions] = useState([]);
  const [autocompleteError, setAutocompleteError] = useState(null);
  const [selectedAddressDetails, setSelectedAddressDetails] = useState('')

  return (
    <Grid container spacing={2} className={classes.flexWrapNowrap}>
      <Grid item className={cn(classes.flexGrow1)}>
        <Autocomplete
          disabled={disabled}
          label="Delivery Address"
          helperText={disabled ? `` : `Start typing to search and select an address`}
          menuItemClasses={classes.menuItem}
          onClear={() => {
            setFilterText(``);
            setAutocompleteError(null);
            setOptions([]);
            if (onClear) {
              onClear();
            }
          }}
          icon={<RoomIcon />}
          onBlur={(typedText) => {
            if (!options) {
              return;
            }
            const foundAddress = options.find((el) => typedText === el.label.replace(/<b>|<\/b>/g, ``));
            if ((!typedText && !options) || (typedText && options && !foundAddress)) {
              const err = `Please select address from the list`;
              setAutocompleteError(err);
              onError(err);
            } else {
              setAutocompleteError(null);
            }
          }}
          onType={(e) => {}}
          defaultValue={defaultValue}
          onSelect={(el) => {
            const withoutHighlight = el.name.replace(/<b>|<\/b>/g, ``);
            setDefaultValue(withoutHighlight);
            if(!el.address.street) {
              setAutocompleteError("Delivery Address requires a street name");
              return;
            }
            setAutocompleteError(null);
            let coords = null;
            console.log('ID' + el.id);
            const coordinates = services.hereMapsService.getCoordinates({ id: el.id }).pipe(
              tap((result) => {
                console.log('result' + result.address);

                // const location = result.response.view[0].result[0].location;

                setSelectedAddressDetails(result.address);
                //coords = location.displayPosition;
                coords = result.position;
              }),
              switchMap((result) => {
                //return services.hereMapsService.getServiceablePlants(result.response.view[0].result[0].location.displayPosition);
                return services.hereMapsService.getServiceablePlants(result.position);
              }),
            );
            coordinates.subscribe((result) => {
              if (result.length > 0) {
                onSelect({ coords, address: withoutHighlight, details: el.address });
              } else {
                onError(result);
              }
            });
          }}
          getInputRef={(inputRef) => {
            const keyEvent = fromEvent(inputRef, `keydown`);
            const changeEvent = fromEvent(inputRef, `change`);
            const mergedEvents$ = merge(changeEvent, keyEvent);

            const allEvents$ = mergedEvents$.pipe(
              debounceTime(300),
              switchMap((el) => {
                // setFilterText(result);
                return services.hereMapsService.getAddressSuggestions({ keywords: el.target.value });
              }),
            );
            allEvents$.subscribe({
              next: (result) => {
                if (!result.items) {
                  return;
                }
                if (result.items.length === 0) {
                  setOptions([]);
                  const err = `We cannot locate above address`;
                  setAutocompleteError(err);
                  onError(err);
                } else {
                  const updatedSuggestions = JSON.parse(JSON.stringify(result.items)).map((el) => {
                    // create label and as e.g. housenumber might be not provided resulting in label starting with ", " strip this if its at the beginning of the label
                    const label = `${el.address.houseNumber ? el.address.houseNumber : ``}${el.address.street ? ` ${el.address.street}` : ``}${
                      el.address.district ? `, ${el.address.district}` : ``
                    }${el.address.city && !el.address.district ? `, ${el.address.city}` : ``}${el.address.stateCode ? `, ${el.address.stateCode}` : ``}${
                      el.address.countryName ? `, ${el.address.countryName}` : ``
                    } `.replace(/^,\s/, ``);

                    return {
                      ...el,
                      label,
                    };
                  });
                  setOptions(
                    updatedSuggestions.filter(suggestion => suggestion.address.state)
                  );
                }
              },
              error: (err) => {
                const message = `There is a problem with autosuggest feature. Please check your connection or refresh the page and try again`;
                setAutocompleteError(message);
              },
            });
          }}
          error={autocompleteError || mandatoryFieldError}
          options={
            !options || options.length === 0
              ? []
              : options
                  .map((el, i) => {
                    return {
                      name: el.label,
                      id: el.id,
                      address: el.address,
                      component: (
                        <Typography variant="body2" key={el.id}>
                          <span dangerouslySetInnerHTML={{ __html: el.label }} />
                        </Typography>
                      ),
                    };
                  })
                  .filter((el) => el.name.toLowerCase().includes(filterText.toLowerCase()))
          }
          placeholder="Where to?"
          fullWidth
          isLoading={false}
        />
        {selectedAddressDetails && !selectedAddressDetails.houseNumber && (
          <div className={classes.marginTop2unit}>
            <PlaceOrderErrorMessage
                  message={
                    <React.Fragment>
                      <Typography variant="body2" className={classes.errorText}>
                        Please proceed to Driver Instructions to provide more delivery address information as we couldn't find an exact match for the address.
                      </Typography>
                    </React.Fragment>
                  }
                />
          </div>)}
      </Grid>
    </Grid>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
HereMapsAutocomplete.propTypes = {
  services: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  defaultAddress: PropTypes.string,
  onSelect: PropTypes.func,
  onClear: PropTypes.func,
  onError: PropTypes.func,
  disabled: PropTypes.bool,
};

export default compose(
  withServices,
  withStyles(themeCreateInjectableStyles(HereMapsStyles), { withTheme: true }),
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(HereMapsAutocomplete);
